import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import React from 'react'
import { ForgotPasswordContent } from 'src/public-pages/pages/forgot-password-content'
import { InternalServerErrorContent } from 'src/public-pages/pages/internal-server-error-content'
import { LoginContent } from 'src/public-pages/pages/login-content'
import { NotFoundContent } from 'src/public-pages/pages/not-found-content'
import { RegisterConfirmContent } from 'src/public-pages/pages/register-confirm-content'
import { ResetYourPasswordContent } from 'src/public-pages/pages/reset-your-password-content'
import { SignUpContent } from 'src/public-pages/pages/sign-up-content'
import { ThankYouContent } from 'src/public-pages/pages/thank-you-content'
import { ThankYouSystemeHostContent } from 'src/public-pages/pages/thank-you-systeme-host-content'
import { TwoFactorAuthContent } from 'src/public-pages/pages/two-factor-auth-content'
import { WebsitePublicPageType } from 'src/shared/enums/website-public-page-form-type'
import {
  WebsiteButtonsInterface,
  WebsiteFormFieldsSettings,
  WebsiteThemeInterface,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'

interface PublicPageFormCreatorProps {
  pageType: WebsitePublicPageType
  homePageUrl?: string
  logoUrl?: string
  isCustomDomain?: boolean
  heading?: WebsiteTypographySettingsStylesInterface
  paragraph?: WebsiteTypographySettingsStylesInterface
  theme?: WebsiteThemeInterface
  formFields?: Partial<WebsiteFormFieldsSettings>
  button?: Partial<WebsiteButtonsInterface>
  linkButton?: Partial<WebsiteButtonsInterface>
  token?: string
  isButtonShown?: boolean
  locale?: PageLocaleEnum
}

export const createWebsitePublicPageTypeContent = (
  props: PublicPageFormCreatorProps,
): React.ReactNode => {
  switch (props.pageType) {
    case WebsitePublicPageType.ThankYou:
      if (props.isCustomDomain) {
        return <ThankYouContent {...props} />
      }

      return <ThankYouSystemeHostContent {...props} />
    case WebsitePublicPageType.NotFound:
      return <NotFoundContent {...props} />
    case WebsitePublicPageType.InternalServerError:
      return <InternalServerErrorContent {...props} />
    case WebsitePublicPageType.Register:
      return <SignUpContent {...props} />
    case WebsitePublicPageType.Login:
      return <LoginContent {...props} />
    case WebsitePublicPageType.TwoFactorAuth:
      return <TwoFactorAuthContent {...props} />
    case WebsitePublicPageType.ForgotPassword:
      return <ForgotPasswordContent {...props} />
    case WebsitePublicPageType.ResetPassword:
      return props.token ? (
        <ResetYourPasswordContent {...props} token={props.token} />
      ) : null
    case WebsitePublicPageType.RegisterConfirm:
      return props.token ? (
        <RegisterConfirmContent {...props} token={props.token} />
      ) : null
    default:
      return null
  }
}
